<template>
  <n-layout class="main-layout" :native-scrollbar="false">
    <n-layout-header class="header" bordered>
      <div class="header-content">
        <div class="logo-text">深圳市嘉玥禾科技有限公司</div>
      </div>
    </n-layout-header>
    
    <n-layout-content class="content" :native-scrollbar="false">
      <div class="hero-section">
        <n-flex vertical align="center" class="hero-content">
          <div class="title animate-up">让我们一起做些<br><span class="gradient-text">时髦又酷</span>的东西吧！</div>
          <div class="sub-title animate-up delay-1">Let's make something trendy and cool!</div>
          
          <n-flex class="ability-flex animate-up delay-2" justify="center" :size="32" :wrap="false">
            <div class="ability-wrapper">
              <AbilityItem image="home_design.webp" title="精美设计" text="Android、iOS、Web"/>
            </div>
            <div class="ability-wrapper">
              <AbilityItem image="home_developer.webp" title="高效开发" text="移动应用、后端开发速度与品质"/>
            </div>
            <div class="ability-wrapper">
              <AbilityItem image="home_data.webp" title="发布运营" text="应用数据统计、用户服务、快速分析"/>
            </div>
          </n-flex>
        </n-flex>
      </div>

      <div class="section-container">
        <div class="section-title">业务简介</div>
        <div class="section-desc">
          移动端：Android、iOS、微信小程序<br/>
          Web端：Vue、Flutter 框架的网页应用<br/>
          后端：Golang、Kotlin、Rust 开发的后台系统<br/>
          从应用开发直至部署、运营数据分析，为用户提供便捷高效的一站式服务。
        </div>
        
        <n-flex class="ability-flex" justify="center" :size="32" :wrap="false">
          <div class="ability-wrapper">
            <AbilityItem image="home_mobile.webp" title="移动应用开发" text="Android、iOS、微信小程序"/>
          </div>
          <div class="ability-wrapper">
            <AbilityItem image="home_web.webp" title="网页应用开发" text="Vue、Flutter 框架开发"/>
          </div>
          <div class="ability-wrapper">
            <AbilityItem image="home_backend.webp" title="服务的开发" text="Golang、Kotlin、Rutt、Python 语言开发"/>
          </div>
        </n-flex>
      </div>

      <div class="section-container">
        <div class="section-title">我们的产品</div>
        <div class="apps-grid">
          <AppShowItem icon="ps/icon.webp" name="PS美图AI修图"
                       text="一款好用智能的图片处理修图手机软件，超多强大的功能，一键处理照片美化"
                       download-url="https://www.pgyer.com/LgQdwoMZ"
                       :store-images="psStoreImages"/>
          <AppShowItem icon="aimage/icon.webp" name="AI魔术修图"
                       text="AI魔术修图，通过先进的人工智能技术，智能识别图像，自动优化色彩、亮度、对比度，让你的照片更具艺术感。"
                       download-url="https://www.pgyer.com/sOBEOZnd"
                       :store-images="aimageStoreImages"/>
          <AppShowItem icon="lr/icon.webp" name="LR图片映像调色"
                       text="LR图片映像调色，专业移动调色软件，智能AI辅助修图"
                       download-url="https://www.pgyer.com/EXCp6xHL"
                       :store-images="lrStoreImages"/>
          <AppShowItem icon="headshot/icon.png" name="最美映像证件照"
                       text="智能证件照制作，一键抠图，智能物体擦除软件"
                       download-url="https://www.pgyer.com/WyTnrber"
                       :store-images="headShotStoreImages"/>
          <AppShowItem icon="widgets/icon.webp" name="极简小组件"
                       text="轻巧实用的桌面小工具，让你的手机界面更简洁高效。"
                       download-url="https://www.pgyer.com/VUyTafpP"
                       :store-images="widgetsStoreImages"/>
          <AppShowItem icon="cook/icon.webp" name="做饭指南"
                       text="「做饭指南」—— 您的贴心烹饪向导，轻松制作美味佳肴"
                       download-url="https://www.pgyer.com/ZSnzmSj8"
                       :store-images="cookStoreImages"/>
          <AppShowItem icon="focus/icon.webp" name="番茄专注时钟"
                       text="专注，始于番茄。你的高效学习工作伴侣。"
                       download-url="https://www.pgyer.com/MAfBaDRS"
                       :store-images="focusStoreImages"/>
          <AppShowItem icon="ccd/icon.webp" name="Candy CCD Cam"
                       text="重温黄金年代，一键拍出经典CCD、复古胶片与Y2K数码质感。"
                       download-url="https://www.pgyer.com/candyccdcam"
                       :store-images="ccdStoreImages"/>
        </div>
      </div>
    </n-layout-content>
    
    <n-layout-footer class="footer">
      <n-flex vertical align="center" :size="12">
        <n-flex align="center" :size="24" class="footer-info">
          <div>地址：深圳市福田区沙头街道天安社区泰然四路泰然科技园210栋七层7C343</div>
          <div>电话：+86 18128843153</div>
        </n-flex>
        <n-flex align="center" :size="24" class="footer-links">
          <n-flex align="center" @click="toPolice" class="link-item">
            <n-image width="16" height="16" src="home_police.webp" preview-disabled/>
            <div>粤公网安备44030002006068号</div>
          </n-flex>
          <div @click="toBeian" class="link-item">粤ICP备2024309628号</div>
        </n-flex>
      </n-flex>
    </n-layout-footer>
  </n-layout>
</template>

<script>
import {NFlex, NImage, NLayout, NLayoutContent, NLayoutFooter, NLayoutHeader} from "naive-ui";
import AbilityItem from "@/components/AbilityItem.vue";
import AppShowItem from "@/components/AppShowItem.vue";

const psStoreImages = ['ps/1.jpg', 'ps/2.jpg', 'ps/3.jpg', 'ps/4.jpg', 'ps/5.jpg'];
const aimageStoreImages = ['aimage/1.webp', 'aimage/2.webp', 'aimage/3.webp', 'aimage/4.webp', 'aimage/5.webp'];
const lrStoreImages = ['lr/1.jpg', 'lr/2.jpg', 'lr/3.jpg', 'lr/4.jpg', 'lr/5.jpg'];
const headShotStoreImages = ['headshot/1.jpg', 'headshot/2.jpg', 'headshot/3.jpg', 'headshot/4.jpg', 'headshot/5.jpg'];
const widgetsStoreImages = ['widgets/1.jpg', 'widgets/2.jpg', 'widgets/3.jpg', 'widgets/4.jpg', 'widgets/5.jpg'];
const cookStoreImages = ['cook/1.jpg', 'cook/2.jpg', 'cook/3.jpg', 'cook/4.jpg', 'cook/5.jpg'];
const focusStoreImages = ['focus/1.jpg', 'focus/2.jpg', 'focus/3.jpg', 'focus/4.jpg', 'focus/5.jpg'];
const ccdStoreImages = ['ccd/1.jpg', 'ccd/2.jpg', 'ccd/3.jpg', 'ccd/4.jpg', 'ccd/5.jpg'];

export default {
  name: 'HomeView',
  components: {NImage, AppShowItem, NLayoutFooter, AbilityItem, NFlex, NLayoutContent, NLayoutHeader, NLayout},
  methods: {toBeian, toPolice},
  setup() {
    return {
      psStoreImages,
      aimageStoreImages,
      lrStoreImages,
      headShotStoreImages,
      widgetsStoreImages,
      cookStoreImages,
      focusStoreImages,
      ccdStoreImages
    }
  }
}

function toBeian() {
  window.open("https://beian.miit.gov.cn/", '_blank')
}

function toPolice() {
  window.open("https://beian.mps.gov.cn/#/query/webSearch", '_blank')
}
</script>

<style scoped>
.main-layout {
  background: transparent;
  min-height: 100vh;
}

.header {
  background: rgba(16, 16, 20, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 64px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--glass-border);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 24px;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #fff, #ccc);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content {
  background: transparent;
}

.hero-section {
  padding: 80px 24px 60px;
  text-align: center;
}

.title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 16px;
  color: #fff;
}

.gradient-text {
  background: linear-gradient(135deg, #63e2b7 0%, #a064ff 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sub-title {
  font-size: 20px;
  color: var(--text-secondary);
  margin-bottom: 60px;
}

.ability-flex {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.ability-wrapper {
  flex: 1;
  max-width: 360px;
}

.section-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 60px 24px;
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #63e2b7, #a064ff);
  border-radius: 2px;
}

.section-desc {
  text-align: center;
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin-bottom: 40px;
  background: var(--glass-bg);
  padding: 32px;
  border-radius: 24px;
  border: 1px solid var(--glass-border);
}

.footer {
  background: rgba(0, 0, 0, 0.3);
  padding: 40px 24px;
  margin-top: 60px;
  border-top: 1px solid var(--glass-border);
}

.footer-info, .footer-links {
  color: var(--text-secondary);
  font-size: 14px;
}

.link-item {
  cursor: pointer;
  transition: color 0.2s;
}

.link-item:hover {
  color: var(--primary-color);
}

/* Animations */
.animate-up {
  opacity: 0;
  animation: fadeInUp 0.8s ease forwards;
}

.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
